import { PBTMessages } from '../../../Services/PBTConstants';

export const AttestationPanelMessages = {
  // General
  selectCasePrompt: 'Select a case from the table above to view workflow actions.',
  attestationNotAvailable: 'Attestation is not available for this case. Current status:',
  currentStepTitle: 'Current Step: Attestation',
  currentStepSubtitle: 'Step 5 of 7',
  managerAttestationTitle: 'Manager Attestation',
  attestationSubmissionTitle: 'Attestation Submission',

  // Summary card
  assignedManagerLabel: 'Assigned Manager',
  termConvDateLabel: 'Term Conv Date',
  daysWaitingLabel: 'Days Waiting',
  statusAwaiting: 'Date & Attestation Pending',
  blockedByFlagNote: 'This case is flagged GER/WIT or LOA. Attestation is blocked until the flag is reviewed and cleared, or the case is paused for review.',
  blockedManagerNote: PBTMessages.ManagerFlaggedComplexity,

  // Buttons
  attestAsManagerBtn: 'Attest as Manager',
  attestAsManagerHint: 'Complete Attestation for Termination Conversation',
  completeAttestationBtn: 'Complete Attestation',
  completeAttestationHint: 'Manager or HRC completes the attestation',
  attestOnBehalfBtn: 'Attest on Behalf of Manager',
  attestOnBehalfHint: 'HRC can complete attestation when manager is unable',
  adminAttestationHint: 'Admin can complete attestation as an override',
  sendReminderBtn: 'Send Reminder',
  pauseCaseBtn: 'Pause Case',
  resumeCaseBtn: 'Resume Case',
  cancelCaseBtn: 'Cancel Case',
  bypassManagerBtn: 'Bypass Manager',
  submitAttestationBtn: 'Submit Attestation',
  cancelBtn: 'Cancel',
  confirmBtn: 'Confirm',

  // Success state
  successTitle: 'Attestation Submitted',
  successSubtitle: 'Thank you. The offboarding process has been initiated.',
  effectiveTermDateLabel: 'Effective Termination Date:',
  lossOfAccessDateLabel: 'Loss of Access Date:',

  // Modal / Form
  modalTitle: 'Manager Attestation',
  modalTitleOnBehalf: 'Attest on Behalf of Manager',
  instructions: 'Please attest below once you have completed the employment termination conversation with the below employee.',
  instructionsBold: 'Do not attest if you have not completed the conversation.',
  employeeAliasLabel: 'Employee Alias:',
  employeeNameLabel: 'Employee Name:',
  employeePernLabel: 'Employee PERN:',
  importantNoteTitle: 'Important Note:',
  importantNoteText:
    'Confirming that the employment termination conversation has occurred will trigger delivery of Leaving Microsoft information to the individual and initiate the offboarding process. The individual\'s system and building access will be removed within approximately 15 minutes to 2 hours.',
  sevenDayStateWarning: '7-Day Notice State: The termination effective date will be 7 calendar days after the attestation date.',
  checkboxLabel: 'Have you completed the Term Conversation?',
  submittingLabel: 'Submitting attestation...',

  // Confirmation dialog
  confirmDialogTitle: 'Confirm Attestation',
  confirmDialogText:
    'Please attest only if you have completed the termination conversation with the employee. Confirm to proceed or cancel if not completed.',
  validationMessage: 'Please confirm that you have completed the termination conversation before proceeding.',
};
